import { SET_MAIL_ACTIVITY_FILTER } from '../actions/types';

const initialState = {
  filter: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MAIL_ACTIVITY_FILTER:
      return {
        ...state,
        filter: action.payload
      };
    default:
      return state;
  }
};